import { render, staticRenderFns } from "./HomeMobileBottomFixedNav.vue?vue&type=template&id=0f8504b8&scoped=true&"
import script from "./HomeMobileBottomFixedNav.vue?vue&type=script&lang=js&"
export * from "./HomeMobileBottomFixedNav.vue?vue&type=script&lang=js&"
import style0 from "./HomeMobileBottomFixedNav.vue?vue&type=style&index=0&id=0f8504b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8504b8",
  null
  
)

export default component.exports